import { Tooltip } from '@design/components/tooltip/Tooltip';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './WithNAFallback.module.scss';

export interface WithNAFallbackProps {
  value: React.ReactNode;
  check?: boolean;
  useFallbackDash?: boolean;
  tooltip?: string;
  containerPadding?: string | number;
  className?: string;
}

export const WithNAFallback = ({
  value,
  check = true,
  useFallbackDash = false,
  tooltip,
  containerPadding,
  className,
}: WithNAFallbackProps) => {
  const { t } = useTranslation('common');

  if (check && value) {
    return value;
  }

  return (
    <Tooltip label={tooltip} disabled={!tooltip}>
      <div
        className={clsx(styles.container, className)}
        style={
          containerPadding != null ? { padding: containerPadding } : undefined
        }
      >
        <span
          className={clsx(styles.text, {
            [styles.useDash]: useFallbackDash,
          })}
          data-testid="table-cell-empty-value"
        >
          {useFallbackDash ? '-' : t('common:table.na')}
        </span>
      </div>
    </Tooltip>
  );
};
